import * as Sentry from '@sentry/react'

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined
const APP_ENV = import.meta.env.VITE_APP_ENV as string || 'development'
const RELEASE = import.meta.env.VITE_SENTRY_RELEASE as string | undefined

export function initSentry(): void {
  if (!SENTRY_DSN) {
    return
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: APP_ENV,
    release: RELEASE || `slac-checkout@${APP_ENV}`,
    enabled: APP_ENV !== 'development',

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
    ],

    // Performance: sample 20% in prod, 100% in staging
    tracesSampleRate: APP_ENV === 'production' ? 0.2 : 1.0,

    // Session replay: 10% normal, 100% on error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // Filter noise
    ignoreErrors: [
      'ResizeObserver loop',
      'Non-Error promise rejection',
      'Network Error',
      'Load failed',
      'Failed to fetch',
    ],

    beforeSend(event) {
      // Strip PII from payment-related breadcrumbs
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.map((breadcrumb) => {
          if (breadcrumb.data?.url?.includes('/payment/')) {
            breadcrumb.data = { ...breadcrumb.data, body: '[REDACTED]' }
          }
          return breadcrumb
        })
      }
      return event
    },
  })
}

export { Sentry }
